import React from 'react';
import {ErrorBoundary as SentryErrorBoundary} from '../../../Services/Sentry';

const ErrorBoundary = ({ children, fallback, fullPage = false }) => {

    const defaultFallback = <div className={
        fullPage ? 'h-[100vh] w-[100vw] flex items-center justify-center' : 'max-w-[80%] mx-auto my-5'
    }>
        <div className="p-4 rounded-xl bg-red-700/20 text-red-700 border border-red-700"
            onClick={() => window.location.reload()}
        >
            <p className="font-bold mb-2">Sorry, an error occurred 😞</p>
            <p>Tap here to reload and try again.</p>
        </div>
    </div>

    return <SentryErrorBoundary showDialog fallback={fallback ?? defaultFallback}>
        {children}
    </SentryErrorBoundary>
}

export default ErrorBoundary;
